import { setLoadingFalse, setLoadingTrue } from "../../global/config/Action/loadingActions.ts";
import store from "../../global/config/store.ts";
import { ApiGetAllocations } from "./Apicall.tsx";

type ClientGroup = 'MM' | 'BLOOMS' | 'ALDI';

const getApiBaseUrl = (clientGroup: ClientGroup): string => {
  switch (clientGroup) {
    case 'MM':
      return `${process.env.REACT_APP_API_COMMON_PREFIX}`;
    case 'BLOOMS':
      return `${process.env.REACT_APP_API_BLOOMS_PREFIX}`;
    case 'ALDI':
      return `${process.env.REACT_APP_API_ALDI_PREFIX}`;
    default:
      throw new Error(`Unsupported client group: ${clientGroup}`);
  }
};

export const CustomDownloadPdf = async (allocationId: string, clientGroup: any) => {
  const token = localStorage.getItem('token');

  const data = `?offset=0&limit=10&&allocationId=${allocationId}`;
  try {
    store.dispatch(setLoadingTrue());

    //const res: any = await ApiGetAllocations(data); // assuming this does not need dynamic base URL

    const apiBaseUrl = getApiBaseUrl(clientGroup);
    const apiVersion = `${apiBaseUrl}api/v1`;
    const route_mediator = 'report';
    const apiUrl = `${apiVersion}/${route_mediator}/mm-scorecard-pdf-download?allocationId=${allocationId}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/pdf',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch PDF');
    }

    const blob = await response.blob();
    const pdfBlob = new Blob([blob], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(pdfBlob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'downloaded_file.pdf';
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF:', error);
    alert('Failed to download PDF: ' + error.message);
  } finally {
    store.dispatch(setLoadingFalse());
  }
};
